import './chart.style.less'

import { Doughnut } from 'react-chartjs-2'
import { cloneDeep } from 'lodash'
import { useState, useLayoutEffect } from 'react'
interface props {
  options: any
  data: any
}

function GaugeTargetChart({ options, data }: props) {
  const [plugins, setPlugins] = useState<any>()

  useLayoutEffect(() => {
    const plugins = [
      {
        id: 'liveboard',
        beforeInit: function (chart) {
          // Get reference to the original fit function
          const originalFit = chart.legend.fit
          // Override the fit function
          chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)()
            this.height += 10
          }
        },
      },
    ]

    setPlugins(plugins)
  }, [])

  const chartOptions: any = {
    ...cloneDeep(options),
    tooltips: { enabled: false },
    hover: { mode: null },
    events: [],
    borderColor: 'rgba(0,0,0,0)',
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        display: true,
        labels: {
          usePointStyle: true,
          pointStyle: 'dash',
          color: 'rgba(0,0,0,0)',
          backgroundColor: 'rgba(0,0,0,0)',
        },
      },
      datalabels: {
        display: false,
      },
    },
  }

  return (
    <Doughnut
      className="gauge-chart-target-container"
      redraw
      data={data}
      options={chartOptions}
      plugins={plugins}
    />
  )
}

export default GaugeTargetChart
